import React from 'react';
import { Box, Typography } from '@mui/material';

import { useIsPhone } from '@hooks';

interface IListHeaderProps {
  title: string;
  filtersDialog?: React.ReactNode;
  summary?: React.ReactNode;
}

export const ListHeader: React.FC<IListHeaderProps> = ({
  title,
  filtersDialog,
  summary,
}) => {
  const isPhone = useIsPhone();

  return (
    <Box
      px={2}
      pt={3}
      display="flex"
      alignItems={isPhone ? 'center' : 'baseline'}
      gap={1.5}
    >
      <Typography variant="h2" typography={{ xs: 'h3', tablet: 'h2' }}>
        {title}
      </Typography>
      {filtersDialog}
      {!isPhone && Boolean(summary) && (
        <Typography variant="body2" color="text.secondary">
          {summary}
        </Typography>
      )}
    </Box>
  );
};
